exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Ripple {\n    position: absolute;\n    background: rgba(255, 255, 255, 0.3);\n    border-radius: 50%;\n    opacity: 1;\n    transform: scale(0);\n}\n\n.Ripple-outline {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.Ripple.is-reppling {\n    animation: ripple 0.5s linear;\n}\n\n.Ripple-parent {\n    position: relative;\n    overflow: hidden;\n    touch-action: none;\n}\n\n@keyframes ripple {\n    100% {\n        opacity: 0;\n        transform: scale(3);\n    }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/Waves.css
// module id = 55
// module chunks = 0